// src/components/Contact.jsx
import React from 'react';
// Importa el SVG (o PNG) de tu ícono
import InstagramIcon from '../assets/instagram.png';
import WhatsAppIcon from '../assets/whatsapp.png';
import '../styles/Contact.css';

const Contact = () => {
  // Número de WhatsApp
  const whatsappNumber = '+541164202054';
  const prefilledMessage = encodeURIComponent(
    '¡Hola! Quisiera más información sobre los servicios de FV Catering.'
  );
  const whatsappLink = `https://api.whatsapp.com/send?phone=${whatsappNumber}&text=${prefilledMessage}`;

  // Enlace a tu perfil de Instagram
  const instagramLink = 'https://instagram.com/fvs_catering';

  return (
    <section id="contacto" className="contact-section">
      <div className="container">
        <h2 className="contact-title">Contáctanos</h2>
        <p className="contact-subtitle">
          Escríbenos por WhatsApp y con gusto te responderemos en breve.
        </p>

        <div className="contact-buttons">
          {/* Botón WhatsApp */}
          <a
            href={whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-whatsapp"
          >
            {/* Si quisieras ícono propio, importar igual que Instagram */}
            <img
              src={WhatsAppIcon}
              alt="WhatsApp"
              className="whatsapp-icon"
            />
            <span className="whatsapp-text">Chatear por WhatsApp</span>
          </a>
        </div>

        {/* Bloque adicional con ícono SVG */}
        <div className="contact-instagram-block">
          <p className="contact-instagram-text">
            Si tenés alguna duda, contáctanos por Instagram
          </p>

          <a
            href={instagramLink}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-instagram-contact"
          >
            {/* Aquí usamos el SVG importado */}
            <img
              src={InstagramIcon}
              alt="Instagram"
              className="instagram-icon-contact"
            />
            <span className="instagram-text-contact">
              Visítanos en Instagram
            </span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default Contact;
